export default __webpack_public_path__ + "static/media/bg-tent.721462ee.jpg";